import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { setPathFrom } from '@cannect/hooks/usePathsRedirect'
import { Button } from '@cannect/new-components/atoms/Button'
import * as Dialog from '@cannect/new-components/atoms/Dialog'
import { trackRecurrency } from '@cannect/services/events'
import { CART_LINK_CYCLE_PARAM } from '@cannect/services/resources/recurrency/constants'
import { recurrencyCopy } from '../copy'

export type RecurrencyLoginPromptProps = {
  open: boolean
  cartId: string
  cycleDays: number
  onClose: () => void
}

const CART_LINK_PATH = '/carrinho-wa'

// 010: aviso do carrinho do link sem sessão. Entrar/Criar conta levam ao login
// ou cadastro com volta ao mesmo carrinho e o ciclo escolhido na URL (FR-006,
// FR-008). `@CANNECT_FROM_PATH` é só o transporte de redirect que já existe.
export const RecurrencyLoginPrompt = ({ open, cartId, cycleDays, onClose }: RecurrencyLoginPromptProps) => {
  const history = useHistory()
  const copy = recurrencyCopy.cartLink

  useEffect(() => {
    if (!open) return
    trackRecurrency('recurrency_cart_link_login_prompt', { origin: 'checkout', source: 'cart_link', cycleDays })
    // eslint-disable-next-line react-hooks/exhaustive-deps -- um evento por abertura
  }, [open])

  const goTo = async (pathname: '/login' | '/cadastro') => {
    const search = `?cart_id=${encodeURIComponent(cartId)}&${CART_LINK_CYCLE_PARAM}=${cycleDays}`
    await setPathFrom(`${CART_LINK_PATH}${search}` as any)
    history.push({ pathname, state: { from: { pathname: CART_LINK_PATH, search } } })
  }

  return (
    <Dialog.Root open={open} onOpenChange={(value) => !value && onClose()}>
      <Dialog.Content className="max-w-md">
        <Dialog.Header>
          <Dialog.Title>{copy.loginTitle}</Dialog.Title>
          <Dialog.Description className="text-gray-700">{copy.loginBody}</Dialog.Description>
        </Dialog.Header>
        <Dialog.Footer className="mt-4 gap-2">
          <Button variant="outline_light" onClick={() => goTo('/cadastro')}>
            {copy.register}
          </Button>
          <Button onClick={() => goTo('/login')}>{copy.login}</Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  )
}
